import React from 'preact';

export default function Weight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20.01 17.62">
      <g id="weight 1" clip-path="url(#clip0_250_32840)">
        <g id="Layer_1-2">
          <path id="Vector" d="M19.8065 0H0.203666C0.0916497 0 0 0.0916497 0 0.203666V1.56823C0 1.68024 0.0916497 1.77189 0.203666 1.77189H19.8065C19.9185 1.77189 20.0102 1.68024 20.0102 1.56823V0.203666C20.0102 0.0916497 19.9185 0 19.8065 0ZM19.8065 11.7923H0.203666C0.0916497 11.7923 0 11.8839 0 11.9959V17.4134C0 17.5255 0.0916497 17.6171 0.203666 17.6171H19.8065C19.9185 17.6171 20.0102 17.5255 20.0102 17.4134V11.9959C20.0102 11.8839 19.9185 11.7923 19.8065 11.7923ZM19.8065 5.01018H0.203666C0.0916497 5.01018 0 5.10183 0 5.21385V8.58452C0 8.69654 0.0916497 8.78819 0.203666 8.78819H19.8065C19.9185 8.78819 20.0102 8.69654 20.0102 8.58452V5.21385C20.0102 5.10183 19.9185 5.01018 19.8065 5.01018Z" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_250_32840">
          <rect width="20" height="17.6069" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}